import { render, staticRenderFns } from "./bina_wataemir.vue?vue&type=template&id=b2511af4&"
import script from "./bina_wataemir.vue?vue&type=script&lang=js&"
export * from "./bina_wataemir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports